import React, { memo, useEffect } from 'react';
import { Table } from 'antd';
import { excelIcon } from '../../store/icons';

interface Props {
  tableColumns: any[];
  tableItems: any[];
  fileName: string;
}

const ROW_HEIGHT = 44;
const MAX_ROWS = 5;

const ImportDataPreviewStepItem: React.FC<Props> = memo(({ tableColumns, tableItems, fileName }) => (
  <div className="data-setup-item">
    <div className="file-detail">
      {excelIcon}
      <span>{fileName}</span>
    </div>
    <Table
      className="rs-table"
      rowClassName={(_, idx) => (idx % 2 === 0 ? 'table-row-dark' : 'table-row-light')}
      columns={tableColumns}
      dataSource={tableItems}
      pagination={false}
      showSorterTooltip={false}
      scroll={{ x: 'max-content', y: ROW_HEIGHT * MAX_ROWS }}
      rowKey={(record) => record.id || record.key || JSON.stringify(record)}
    />
  </div>
));

export default ImportDataPreviewStepItem;
